import { useCallback, useState, useRef } from 'react';

export const useOnScreen = (options?: {
  root: Element | null;
  rootMargin: string;
  threshold: number;
}) => {
  const [isIntersecting, setIsIntersecting] = useState<boolean>(false);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);

  const optionsRef = useRef(options);
  optionsRef.current = options;

  const bottomRef = useCallback((node: HTMLDivElement | HTMLLIElement) => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = null;
    }

    if (!node) {
      setIsIntersecting(false);
      return;
    }

    const intersectionObserver = new IntersectionObserver(([entry]) => {

      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }

      debounceTimerRef.current = setTimeout(() => {
        setIsIntersecting(entry.isIntersecting);
        debounceTimerRef.current = null;
      }, 100);
    }, optionsRef.current ?? { root: null, rootMargin: '0px', threshold: 0.5 });

    intersectionObserver.observe(node);
    observerRef.current = intersectionObserver;
  }, []);

  return { bottomRef, isIntersecting, observer: observerRef.current };
};
